import {APIClient} from "../base";
import {RegisterInterface} from "../../../interfaces/RegisterInterface";

const RegisterApi = {
    createAccount: async (model: RegisterInterface) => await APIClient.create('/register', model)
}

export default RegisterApi;
